import TemplateTypeCombobox from 'components/comboboxes/TemplateTypeCombobox';
import MandatoryAsterisk from 'components/common/MandatoryAsterisk';
import MutedText from 'components/common/MutedText';
import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTranslation } from 'react-i18next';
import type { ETemplateType } from 'types/template/template.types';
import { useCreateTemplateState } from './CreateTemplateContext';

const CreateTemplateBasicInfo = () => {
  const { t } = useTranslation('Templates');
  const { form } = useCreateTemplateState();
  const { newTemplate, onNameChange, onTypeChange, onModeChange } = form;
  const { name, type, mode } = newTemplate;

  return (
    <div className="rounded-xl border border-slate-200/70 bg-white p-4 shadow-xs">
      <div className="grid gap-4">
        <div>
          <HubertLabel htmlFor="create-template-name">
            {t('basicInfo.nameLabel')}
            <MandatoryAsterisk />
          </HubertLabel>
          <HubertInput
            id="create-template-name"
            value={name}
            placeholder={t('basicInfo.namePlaceholder')}
            onChange={(e) => onNameChange(e.target.value)}
          />
          <MutedText text={t('basicInfo.nameHint')} />
        </div>

        <div>
          <HubertLabel htmlFor="create-template-type-combobox">
            {t('basicInfo.typeLabel')}
            <MandatoryAsterisk />
          </HubertLabel>
          <TemplateTypeCombobox
            id="create-template-type-combobox"
            onValueChange={(value) => onTypeChange(value as ETemplateType)}
            value={type}
          />
          <MutedText text={t('basicInfo.typeHint')} />
        </div>

        <div>
          <HubertLabel>{t('basicInfo.modeLabel')}</HubertLabel>
          <div className="mt-2 grid gap-3 sm:grid-cols-2">
            <label className="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-200 px-3 py-2 text-sm shadow-xs transition hover:border-slate-300">
              <input
                type="radio"
                name="template-mode"
                className="h-4 w-4 accent-black"
                checked={mode === 'copy'}
                onChange={() => onModeChange('copy')}
              />
              <div>
                <div className="font-medium">{t('basicInfo.modeCopyTitle')}</div>
                <div className="text-xs text-slate-500">{t('basicInfo.modeCopyDescription')}</div>
              </div>
            </label>
            <label className="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-200 px-3 py-2 text-sm shadow-xs transition hover:border-slate-300">
              <input
                type="radio"
                name="template-mode"
                className="h-4 w-4 accent-black"
                checked={mode === 'create'}
                onChange={() => onModeChange('create')}
              />
              <div>
                <div className="font-medium">{t('basicInfo.modeCreateTitle')}</div>
                <div className="text-xs text-slate-500">{t('basicInfo.modeCreateDescription')}</div>
              </div>
            </label>
          </div>
          {mode === 'create' ? (
            <MutedText className="text-warning-500" text={t('basicInfo.modeCreateWarning')} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CreateTemplateBasicInfo;
